import React from 'react';

import { useCanViewBestOfWolt, MessagePage } from 'modules/experience-core';
import { ExperienceVenueEntity, PageHeader } from 'modules/experience-core';
import { useExperienceModuleContext } from 'modules/experience-core';

import { IndexPage } from '../pages/IndexPage';

const BestOfWolt = ({ experienceVenueEntity }: { experienceVenueEntity: ExperienceVenueEntity }) => {
  const venue = experienceVenueEntity.experienceEntityObject;
  const isDaasVenue = venue.type === 'daas';

  return !isDaasVenue ? (
    <>
      <PageHeader />
      <IndexPage venueId={venue.id} venueTimezone={venue.timezone} />
    </>
  ) : (
    // show not supported page
    <MessagePage variant="not_supported" />
  );
};

export const ExperienceBestOfWolt = () => {
  const { selectedExperienceVenueEntity } = useExperienceModuleContext();
  const { isBestOfWoltEnabled, hasPermissionsForVenues } = useCanViewBestOfWolt(
    selectedExperienceVenueEntity ? [selectedExperienceVenueEntity] : [],
  );

  if (!selectedExperienceVenueEntity) {
    return <MessagePage variant="error" />;
  }

  if (!isBestOfWoltEnabled) {
    return <MessagePage variant="not_supported" />;
  }

  return hasPermissionsForVenues ? (
    <BestOfWolt experienceVenueEntity={selectedExperienceVenueEntity} />
  ) : (
    <MessagePage variant="missing_permissions" />
  );
};
